/* eslint-disable */
import React from 'react'
import { compose } from 'recompose';
import { withStyles, Chip, Checkbox, Typography, IconButton } from '@material-ui/core';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AddCommentIcon from '@material-ui/icons/AddComment';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import BusinessIcon from '@material-ui/icons/Business';
import CloseIcon from '@material-ui/icons/Close';
import DateRangeIcon from '@material-ui/icons/DateRange';
import ErrorIcon from '@material-ui/icons/Error';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import ModeCommentIcon from '@material-ui/icons/ModeComment';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import cn from 'classnames'

import themeCreateInjectableStyles from '../../../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import docketsTableStyles from './DocketsTable.component.styles';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

const DocketsTable = (props) => {
  const {
    classes,
    columns,
    requestSortBy,
    allChecked,
    updateCheckAll,
    dockets,
    updateChecked,
    isChecked,
    sortBy,
    openDetails,
    onMenuClick,
  } = props

  /**
   * Styles value provided based on column name
   */
  const getStyledContent = ({ columnName, value }) => {
    switch (columnName) {
      case `accepted`: {
        if (value) {
          return <Chip className={classes.chip} icon={<PlaylistAddCheckIcon className={classes.chipAcceptedIcon} />} />;
        }
        return <Chip className={classes.chip} icon={<PlaylistAddCheckIcon className={classes.chipNotAcceptedIcon} />} />;
      }
      case `serviceFeesCount`: {
        if (value > 0) {
          return <Chip className={classes.chip} icon={<NoteAddIcon className={classes.chipFeeIcon} />} label={value} />;
        }
        return <Chip className={classes.chip} icon={<NoteAddIcon className={classes.chipNoFeeIcon} />} label="0" />;
      }
      case `notes`: {
        if (value > 0) {
          return <Chip className={classes.chip} icon={<ModeCommentIcon className={classes.chipNotesAddedIcon} />} label={value} />;
        }
        return <Chip className={classes.chip} icon={<ModeCommentIcon className={classes.chipNoNotesAddedIcon} />} label="0" />;
      }
      case `docketStatus`: {
        // VALUES COMING FROM API FOR STATUSES NEEDS TO BE AGREED ON THEN CONDITIONS BELOW NEED TO BE ADJUSTED. FOR NOW THIS WILL DO
        if (value === `COMPLETE`) {
          return <Chip className={classes.statusCompleted} label="COMPLETE" />;
        }
        if (value === `IN_PROGRESS`) {
          return <Chip className={classes.statusInProgress} label="IN PROGRESS" />;
        }
        return <Chip className={classes.green} label={value} />;
      }
      default:
        return value;
    }
  };

  return (
    <Table aria-labelledby="dockets" className={classes.table}>
      <TableHead>
        <TableRow>
          <TableCell className={classes.checkboxColumn} padding="checkbox">
            <Checkbox checked={allChecked} color="primary" onChange={updateCheckAll} />
          </TableCell>
          {columns &&
            columns
              .filter((column) => column.selected)
              .map((column) => {
                return (
                  <TableCell
                    align="left"
                    className={cn(classes.tableHeaderCell, classes.whiteSpaceNowrap, column.sortable && classes.cursorPointer)}
                    id={column.name}
                    key={column.name}
                    onClick={() => (column.sortable ? requestSortBy(column) : null)}
                    padding="default"
                  >
                    <Typography variant="subtitle2">
                      {column.label}
                      {sortBy.name === column.name && <ArrowBackIcon className={!sortBy.asc ? classes.arrowUp : classes.arrowDown} />}
                    </Typography>
                  </TableCell>
                );
              })}
          <TableCell align="left" className={classes.whiteSpaceNowrap} padding="default">
            &nbsp;
          </TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {dockets.map((el, i) => {
          const row = { ...el, ticketDate: el.formattedTicketDate };
          return (
            <TableRow
              aria-checked={false}
              className={cn(classes.cursorPointer, classes.docketsTableRow)}
              hover
              key={row.docketNumber + row.orderCode}
              role="checkbox"
              selected={false}
              tabIndex={-1}
            >
              <TableCell className={classes.checkboxColumn} padding="checkbox">
                <Checkbox checked={isChecked(el.docketNumber)} color="primary" onClick={(e) => updateChecked(e, el.docketNumber)} />
              </TableCell>
              {columns
                .filter((column) => column.selected)
                .map((column) => {
                  const mfsdrProp = ['street', 'purchaseCode'].includes(column.name) ? { 'data-mf-replace-inner': MFSDR } : {}
                  return (
                    <TableCell
                      className={classes.tableCell}
                      data-id={`${column.name}_${i}`}
                      key={column.name}
                      onClick={() => openDetails(el)}
                      padding="default"
                      scope="row"
                    >
                      <Typography
                        className={cn(classes.tableCellContent)}
                        component="div"
                        title={row[column.name] ? row[column.name].toString() : ``}
                        variant="body2"
                        { ...mfsdrProp }
                      >
                        {getStyledContent({ columnName: column.name, value: row[column.name] })}
                      </Typography>
                    </TableCell>
                  );
                })}

              <TableCell className={classes.actionsColumn} key="actionsColumn" padding="default" scope="row">
                <IconButton onClick={(e) => onMenuClick(e, el)}>
                  <MoreVertIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  )
}

export default compose(
  withStyles(themeCreateInjectableStyles(docketsTableStyles), { withTheme: true }),
)(DocketsTable)
